const MessengerButton = () => {
  const handleMessengerClick = () => {
    // Open Messenger in a new window/tab
    window.open('https://m.me/gravitypointmedia', '_blank', 'width=400,height=600,scrollbars=yes,resizable=yes');
  };

  return (
    <button
      onClick={handleMessengerClick}
      className="fixed bottom-6 right-6 bg-blue-600 hover:bg-blue-700 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-50"
      aria-label="Send us a message on Facebook Messenger"
      title="Send us a message on Facebook Messenger"
    >
      <svg
        className="w-6 h-6"
        fill="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 0C5.373 0 0 4.974 0 11.111c0 3.498 1.744 6.614 4.469 8.654V24l4.088-2.242c1.092.301 2.246.464 3.443.464 6.627 0 12-4.974 12-11.111C24 4.974 18.627 0 12 0zm1.191 14.963l-3.055-3.258-5.963 3.258L10.732 8.1l3.13 3.258L19.8 8.1l-6.609 6.863z"/>
      </svg>
    </button>
  );
};

export default MessengerButton;
